import React from 'react';
import { Link } from '../../../../components/Link';
import { ReadTime } from '../../../../components/ReadTime';
// import {
//   ArticleNumberOfCommentsAnchor,
// } from '../../../../components/ArticleNumberOfCommentsAnchor';

import { Routes } from '../../../../constants';
import { CamelizedBehaviorArticleResponse } from '../../../../types/api';
import { Typography } from '../../../../wag-react/components/Typography';
import { Box } from '../../../../wag-react/core-components/box';
import { BoxProps } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
export type BehaviorArticleInfoProps = CamelizedBehaviorArticleResponse & BoxProps;
export const BehaviorArticleInfo = ({
  readTime,
  // commentList,
  ...rest
}: BehaviorArticleInfoProps) => <Box gridAutoFlow="column" alignItems="center" justifyContent={['flex-start', 'space-between']} {...rest} data-sentry-element="Box" data-sentry-component="BehaviorArticleInfo" data-sentry-source-file="index.tsx">
    <Flex gridGap={['8px', '24px']} fontSize={['14px', '18px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Link href={Routes.KnowledgeBehaviorGuides} target="_blank" data-sentry-element="Link" data-sentry-source-file="index.tsx">
        <Typography color="inherit" fontFamily="muliSemiBold" fontSize="inherit" style={{
        textTransform: 'uppercase'
      }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          Behavior
        </Typography>
      </Link>
      <Typography fontSize="inherit" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        |
      </Typography>
      <ReadTime mb="unset" fontSize="inherit" textProps={{
      fontSize: 'inherit'
    }} iconProps={{
      fontSize: 'inherit'
    }} data-sentry-element="ReadTime" data-sentry-source-file="index.tsx">
        {readTime.text}
      </ReadTime>

      <Typography display={['block', 'none']} fontSize="inherit" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        |
      </Typography>
    </Flex>

    {/* Removing for now as we don't support temporarily */}
    {/* <ArticleNumberOfCommentsAnchor
      value={commentList?.totalCount || 0}
     /> */}
  </Box>;